var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShoponline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shoponline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.129,
    height: 34.129,
    viewBox: "0 0 34.129 34.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3296",
    "data-name": "Group 3296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3295",
    "data-name": "Group 3295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M17.064,0C9.856,0,0,5.449,0,17.064c0,11.32,9.48,17.064,17.064,17.064,13.013,0,17.064-11.4,17.064-17.064A16.926,16.926,0,0,0,17.064,0ZM13.107,1.606A15.237,15.237,0,0,0,8.9,8.754,15.853,15.853,0,0,1,5.516,6.06,15.988,15.988,0,0,1,13.107,1.606ZM4.783,6.88A16.73,16.73,0,0,0,8.593,9.849a28.852,28.852,0,0,0-.873,6.665h-6.6A15.894,15.894,0,0,1,4.783,6.88Zm0,20.37a15.853,15.853,0,0,1-3.668-9.634h6.6a28.8,28.8,0,0,0,.873,6.665A17.225,17.225,0,0,0,4.783,27.249Zm.732.826A15.854,15.854,0,0,1,8.9,25.382a15.271,15.271,0,0,0,4.212,7.148A16.1,16.1,0,0,1,5.516,28.076Zm11,4.911c-2.862-.363-5.328-3.561-6.658-8.143a16.058,16.058,0,0,1,6.658-1.713v9.856Zm0-10.951a17.092,17.092,0,0,0-6.94,1.727,28.819,28.819,0,0,1-.759-6.147h7.7Zm0-5.522h-7.7a28.819,28.819,0,0,1,.759-6.147,17.146,17.146,0,0,0,6.94,1.727Zm0-5.516A15.93,15.93,0,0,1,9.856,9.285c1.33-4.589,3.8-7.78,6.658-8.143ZM29.345,6.88a15.894,15.894,0,0,1,3.668,9.634h-6.6a28.8,28.8,0,0,0-.873-6.665A17.035,17.035,0,0,0,29.345,6.88Zm-.732-.826a15.853,15.853,0,0,1-3.379,2.694A15.306,15.306,0,0,0,21.022,1.6,16.1,16.1,0,0,1,28.613,6.053Zm-11-4.911c2.862.363,5.328,3.561,6.658,8.143A16.032,16.032,0,0,1,17.615,11Zm0,10.951a17.092,17.092,0,0,0,6.94-1.727,28.819,28.819,0,0,1,.759,6.147h-7.7Zm0,5.522h7.7a28.819,28.819,0,0,1-.759,6.147,16.879,16.879,0,0,0-6.94-1.727Zm0,15.371V23.131a15.93,15.93,0,0,1,6.658,1.713C22.943,29.433,20.477,32.624,17.615,32.987Zm3.406-.464a15.237,15.237,0,0,0,4.212-7.148,15.853,15.853,0,0,1,3.379,2.694A15.988,15.988,0,0,1,21.022,32.523Zm8.324-5.274a17.035,17.035,0,0,0-3.8-2.969,28.852,28.852,0,0,0,.873-6.665h6.6A15.894,15.894,0,0,1,29.345,27.249Z",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoponline);
export default __webpack_public_path__ + "static/media/shoponline.ed780af1b53c3def7c720f5c58736b4a.svg";
export { ForwardRef as ReactComponent };